export default "__VITE_ASSET__p38bm6iT__"